module.exports = __webpack_public_path__ + "img/not-found-1024.518d6c45823025658921ec27ca198379.png";